import type { departments as en } from '@/i18n/locales/en/departments';
import type { Translation } from '@/i18n/types';

export const departments: Translation<typeof en> = {
  page: {
    title: 'Departamentos',
    leadPersonal: 'Departamentos dos quais és membro.',
    leadCompany: 'Departamentos em {{company}}.',
  },
  list: {
    cardTitle: 'Departamentos',
    name: 'Nome',
    company: 'Empresa',
    statistics: 'Estatísticas',
    collectiveConsent: 'Consentimento coletivo',
    inForce: 'em vigor',
    none: '—',
    unattached: 'sem associação',
    empty: 'Ainda sem departamentos aqui.',
    newDepartment: 'Novo departamento',
  },
  compare: {
    cardTitle: 'Comparação de departamentos',
    pageTitle: 'Comparação de departamentos',
    lead: 'A comparar os departamentos cujas estatísticas podes ver.',
    empty: 'Nenhum departamento aqui tem estatísticas que possas ver.',
  },
  detail: {
    thisDepartment: 'departamento',
    edit: 'Editar',
    setVisibility: 'Definir visibilidade',
    collectiveConsent: 'Consentimento coletivo',
    coach: 'Treinador',
    category: 'Categoria',
    type: 'Tipo',
    statistics: 'Estatísticas',
    notRecorded: 'não registado',
    membersCardTitle: 'Membros',
    statsCardTitle: 'Estatísticas',
    settingsCardTitle: 'Definições',
    addPerson: 'Adicionar pessoa',
    name: 'Nome',
    nickname: 'Alcunha',
    login: 'Acesso',
    yes: 'sim',
    no: 'não',
    noMembers: 'Sem membros.',
  },
  form: {
    newTitle: 'Novo departamento',
    newLead:
      'Todo o novo departamento começa apenas com agregados — o estado que protege a privacidade é aquele que obténs sem fazer nada.',
    name: 'Nome',
    category: 'Categoria',
    type: 'Tipo',
    cancel: 'Cancelar',
    create: 'Criar departamento',
    editTitle: 'Editar departamento',
    save: 'Guardar',
    deleteCardTitle: 'Eliminar',
    deleteButton: 'Eliminar este departamento',
    deleteConfirm: 'Eliminar {{name}} definitivamente?',
    deleteKeep: 'Manter',
    deleteYes: 'Sim, eliminar',
    visibilityTitle: 'Visibilidade das estatísticas',
    visibilityLead:
      'individual não expõe ninguém por si só: permite o acesso individual onde uma base de consentimento cobre o membro. Mudar para individual sem um registo coletivo cria uma linha de consentimento pendente para cada membro atual.',
    visibilityAggregate: 'agregado — apenas números de grupo',
    visibilityIndividual: 'individual — acesso por membro onde o consentimento o cobre',
    collectiveConsentTitle: 'Base do consentimento coletivo',
    collectiveConsentLead:
      'Enquanto um registo coletivo estiver em vigor, cobre todos os membros de {{name}}, seja qual for a sua resposta pessoal. As linhas próprias dos membros são mantidas e voltam a produzir efeito quando é revogado.',
    collectiveConsentNote: 'Acordo fora da plataforma (identifica-o com precisão)',
    collectiveConsentRecord: 'Registar base coletiva',
    revokeCardTitle: 'Revogar',
    revokeButton: 'Revogar a base coletiva',
  },
};
